// hooks/useLoads.js
import { useEffect, useState } from "react";
import moment from "moment";
import { utils } from "helper";

export const buildLrEntryFromFormLoad = (formLoad) => ({

    consignor_id: formLoad.party
        ? {
            _id: formLoad.party._id || formLoad.party.value || "",
            name: formLoad.party.name || formLoad.party.label || "",
            contact_no: formLoad.party.contact_no || "",
            is_auto_message: formLoad.party.is_auto_message || false,
            firm_id: formLoad.party.firm_id || {},
            permission_at_dispatch: formLoad.party.permission_at_dispatch || {},
            permission_at_item: formLoad.party.permission_at_item || {},
            ...formLoad.party,
        }
        : {},
    from: {
        from_city: formLoad.fromLocation?.name || "",
        from_state: formLoad.fromLocation?.stateName || "",
        lat: formLoad.fromLocation?.latitude || "",
        long: formLoad.fromLocation?.longitude || "",
    },
    from_location: formLoad.fromLocation?.name || "",
    from_state: formLoad.fromLocation?.stateName || "",
    to: {
        to_city: formLoad.toLocation?.name || "",
        to_state: formLoad.toLocation?.stateName || "",
        lat: formLoad.toLocation?.latitude || "",
        long: formLoad.toLocation?.longitude || "",
    },
    to_location: formLoad.toLocation?.name || "",
    to_state: formLoad.toLocation?.stateName || "",
    eway_bill_number: formLoad.ewayBillNumber || "",
    eway_bill_date: formLoad.ewayExpiryDate || "",
    eway_expiry_date: formLoad.ewayExpiryDate || "",
    mlr_number: formLoad.mlrNumber || "",
    invoice_number: formLoad.invoiceNumber || "",

    // ✅ qty_type aur weight_type formLoad se lo
    lr_material_list:
        formLoad.materialListFromEway?.length > 0
            ? formLoad.materialListFromEway
            : formLoad.productDescription || formLoad.weight || formLoad.quantity || formLoad.salesValue || formLoad.kot
                ? [{
                    product_desc: formLoad.productDescription || "",
                    name: "",
                    material_code: "",
                    hsn_code: null,
                    material_category_id: null,
                    qty: Number(formLoad.quantity) || 0,
                    qty_type: formLoad.qty_type || 1,  // ← formLoad se
                    weight: Number(formLoad.weight) || 0,
                    weight_type: formLoad.weight_type || 1,  // ← formLoad se
                    kot: Number(formLoad.kot) || 0,
                    amount: Number(formLoad.salesValue) || 0,
                }]
                : [],

    firm_id: formLoad.party?.firm_id || {},
});

const useLoads = ({ listofLr2, setListOfLr2, setSelectedLr2, setLrDetele, masterData, isRedirect }) => {
    const [loads, setLoads] = useState(() =>
        isRedirect   // ← redirect se aaya → empty, direct aaya → form load
            ? []
            : [{
                id: `load-${Date.now()}`,
                loadNumber: 1,
                mode: "form",
                qty_type: 1,
                weight_type: 1,
            }]
    );

    // ─── listofLr2 → display loads sync ─────────────────────────────────────────
    useEffect(() => {
        setLoads((prev) => {
            const displayLoads = listofLr2.map((lr, idx) => ({
                id: lr._id || `temp-${idx}`,
                loadNumber: idx + 1,
                mode: "display",

                // Party
                partyName: lr?.consignor_id?.name || "",

                // From location
                fromCity: lr?.from?.from_city || "",
                fromAddress: lr?.unit_id?.code || "-",
                fromContact: lr?.unit_id?.name || "",
                fromZone: lr?.unit_id?.zone_id?.name || "Default",

                // To location
                toCity: lr?.to?.to_city || "",
                toAddress: lr?.consignee_id?.code || "-",
                toContact: lr?.consignee_id?.name || "",
                toZone: lr?.consignee_id?.zone_id?.name || "Default",

                // LR detail
                lrDate: lr?.invoice_date
                    ? moment(lr.invoice_date).format("DD/MM/YYYY")
                    : "-",
                invoiceNumber: lr?.invoice_number || "-",
                lrNumber: lr?.lr_number || "-",
                mlrNumber: lr?.mlr_number || "-",

                // Item totals
                kot: utils.getTotalAmount(lr?.lr_material_list, "kot") || "-",
                qty: utils.getTotalAmount(lr?.lr_material_list, "qty") || "-",
                salesValue: utils.getTotalAmount(lr?.lr_material_list, "amount") || "-",
                weight: utils.getTotalAmount(lr?.lr_material_list, "weight") || "-",

                // ✅ Weight unit — material_weight_type object se
                weightUnit: masterData?.material_weight_type?.[
                    lr?.lr_material_list?.[0]?.weight_type
                ] || "",

                // ✅ Qty unit — material_qty_type_list array se find
                qtyUnit: masterData?.material_qty_type_list?.find(
                    (t) => t?.id === lr?.lr_material_list?.[0]?.qty_type
                )?.name || "",

                // Eway
                ewayNumber: lr?.eway_bill_number || "-",
                ewayExpiryDate: lr?.eway_expiry_date
                    ? moment(lr.eway_expiry_date).format("DD/MM/YYYY")
                    : "-",
                hasEwayField: !!lr._id,
                ewayMandatory: lr?.consignor_id?.permission_at_dispatch?.eway_bill_mandatory === 1,

                // Indent
                indentNumber: lr?.indent_number ? `#${lr.indent_number}` : "-",
                poNumber: lr?.po_number || lr?.po_list?.po_number || "-",

                // Meta
                originalData: lr,
                originalIndex: idx,
                isPlanLoad: !!lr?.plan_id?._id,
            }));

            const formLoads = prev.filter((l) => l.mode === "form");

            // ✅ Form loads ka loadNumber bhi update karo
            const updatedFormLoads = formLoads.map((l, idx) => ({
                ...l,
                loadNumber: displayLoads.length + idx + 1,
            }));

            return [...displayLoads, ...updatedFormLoads];
        });
    }, [listofLr2]);

    // ─── ADD MORE LOADS ───────────────────────────────────────────────────────────
    const handleAddMoreLoads = () => {
        const formLoad = loads.find((l) => l.mode === "form");

        if (formLoad) {
            // ✅ Validate karo
            const errors = validateFormLoad(formLoad);
            console.log("formLoad", formLoad)
            if (Object.keys(errors).length > 0) {
                setLoads((prev) =>
                    prev.map((l) =>
                        l.id === formLoad.id ? { ...l, errors } : l
                    )
                );
                return;
            }

            const newEntry = buildLrEntryFromFormLoad(formLoad);
            console.log(newEntry)
            setListOfLr2((prev) => [...prev, newEntry]);
            setSelectedLr2((prev) => [...prev, newEntry]);
        }

        setLoads((prev) => {
            const nonFormLoads = prev.filter((l) => l.mode !== "form");
            return [
                ...nonFormLoads,
                {
                    id: `load-${Date.now()}`,
                    loadNumber: nonFormLoads.length + 1,
                    mode: "form",
                    qty_type: 1,    // ✅ default
                    weight_type: 1,    // ✅ default
                    errors: {},
                },
            ];
        });
    };

    // ─── REMOVE LOAD ─────────────────────────────────────────────────────────────
    const handleRemoveLoad = (id) => {
        const lrIndex = listofLr2.findIndex(
            (lr, idx) => (lr._id || `temp-${idx}`) === id
        );

        if (lrIndex !== -1) {
            setLrDetele({
                item: listofLr2[lrIndex],
                innerIndex: lrIndex,
                outerIndex: 0,
                title: `Load ${lrIndex + 1}`,
            });
            return;
        }

        // Form load → seedha hata do
        setLoads((prev) => prev.filter((l) => l.id !== id));
    };

    // ─── Clear form load after new LR saved ──────────────────────────────────────
    const clearFormLoad = () => {
        setLoads((prev) =>
            prev.map((l) =>
                l.mode === "form"
                    ? {
                        id: l.id,
                        loadNumber: l.loadNumber,
                        mode: "form",
                        qty_type: 1,    // ✅ reset to default
                        weight_type: 1,    // ✅ reset to default
                    }
                    : l
            )
        );
    };

    return { loads, setLoads, handleAddMoreLoads, handleRemoveLoad, clearFormLoad };
};

export const validateFormLoad = (formLoad) => {
    const errors = {};

    if (!formLoad.party?._id && !formLoad.party?.value) {
        errors.party = "Party is required";
    }
    if (!formLoad.fromLocation?.name) {
        errors.fromLocation = "From location is required";
    }
    if (!formLoad.toLocation?.name) {
        errors.toLocation = "To location is required";
    }
    if (formLoad.ewayBillNumber && formLoad.ewayBillNumber.toString().length !== 12) {
        errors.ewayBillNumber = "Eway bill number must be 12 digits";
    }
    if (formLoad.ewayBillNumber?.toString().length === 12 && !formLoad.ewayExpiryDate) {
        errors.ewayExpiryDate = "Eway expiry date is required";
    }

    if (formLoad.ewayBillNumber?.toString().length === 12 && !formLoad.ewayStartDate) {
        errors.ewayStartDate = "Eway start date is required";
    }

    return errors;
};

export default useLoads;